import { UserRole } from '@src/constants/user'
import { RootState } from '@src/state/types'
import { createSelector } from 'reselect'
import { WritingToolsJWT } from './types'

export const getLoggedIn = (state: RootState): boolean => {
  return state.auth.jwt
    ? !!(state.auth.jwt.cheggTokens && state.auth.jwt.cheggTokens.access_token)
    : false
}

export const getCheggIdToken = (state: RootState): string | undefined => {
  return (
    state.auth.jwt && state.auth.jwt.cheggTokens && state.auth.jwt.cheggTokens.id_token
  )
}

export const getCheggAccessToken = (state: RootState): string | undefined => {
  return state.auth.jwt?.cheggTokens?.access_token
}

export const getPaidMember = (state: RootState): boolean => {
  return state.auth.jwt?.paidMember || false
}

export const getFreeUser = createSelector(
  [getLoggedIn, getPaidMember],
  (isLoggedIn, isPaid) => isLoggedIn && !isPaid
)

export const getEmail = (state: RootState): string | undefined => {
  return state.auth.jwt?.email || undefined
}

export const getUserRole = (state: RootState): UserRole | undefined => {
  return state.auth.jwt ? state.auth.jwt.user_role : undefined
}

export const getUserID = (state: RootState): string | undefined => {
  return state.auth.jwt?.cheggUserUuid || undefined
}

export const getSessionId = (state: RootState): string | undefined => {
  return state.auth.jwt?.sessionId
}

export const getCheggUserUuid = (state: RootState): string | undefined => {
  return state.auth.jwt?.cheggUserUuid || undefined
}

export const getJwt = (state: RootState): WritingToolsJWT | undefined => {
  return state.auth.jwt
}

export function selectAuthFlowInProgress(state: RootState) {
  return state.auth.isInAuthFlow
}

export const getSelectedUserType = (state: Omit<RootState, 'router'>) =>
  state.auth.selectedUserType

export const getSelectedSchoolType = (state: Omit<RootState, 'router'>) =>
  state.auth.selectedSchoolType



// WEBPACK FOOTER //
// ./src/state/auth/selectors.ts